import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../../common2/Badge';
import { ClaimStatus } from '../claims/types';

// biome-ignore-start lint/style/useNamingConvention: external
const claimStatusTitleIntent = {
  in_progress: { intent: 'neutral', title: 'In progress' },
  in_final_review: { intent: 'neutral', title: 'In final review' },
  submitted: { intent: 'neutral', title: 'Submitted' },
  resubmitted: { intent: 'neutral', title: 'Resubmitted' },
  action_required: { intent: 'warning', title: 'Action required' },
  accepted: { intent: 'positive', title: 'Accepted' },
  credit_note_pending: { intent: 'positive', title: 'Credit note pending' },
  successful: { intent: 'positive', title: 'Successful' },
  declined: { intent: 'alert', title: 'Declined' },
  draft: { intent: 'warning', title: 'Draft' },
  escalating: { intent: 'neutral', title: 'Escalating' },
  payment_overdue: { intent: 'warning', title: 'Payment overdue' },
  incorrect_payment: { intent: 'warning', title: 'Incorrect payment' },
  paid: { intent: 'positive', title: 'Paid' },
  unknown: { intent: 'alert', title: 'Unknown' },
};
// biome-ignore-end lint/style/useNamingConvention: external

function ClaimStatusBadge({ status }) {
  const { title, intent } = claimStatusTitleIntent[status] || claimStatusTitleIntent.unknown;

  return <Badge intent={intent}>{title}</Badge>;
}

ClaimStatusBadge.propTypes = {
  status: PropTypes.oneOf(Object.values(ClaimStatus)),
};

export default React.memo(ClaimStatusBadge);